export default __webpack_public_path__ + "assets/images/Payment_09.7b2047.webp";